"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_popper_1 = require("react-popper");
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var PopperContext_1 = require("./PopperContext");
var usePopperPopper = function (_a) {
    if (_a === void 0) { _a = {}; }
    var referenceElementProp = _a.referenceElement, _b = _a.modifiers, modifiers = _b === void 0 ? [] : _b, _c = _a.strategy, strategy = _c === void 0 ? 'fixed' : _c, _d = _a.eventsEnabled, eventsEnabled = _d === void 0 ? true : _d, _e = _a.offset, offsetOption = _e === void 0 ? [0, 0] : _e, options = __rest(_a, ["referenceElement", "modifiers", "strategy", "eventsEnabled", "offset"]);
    var popperRef = react_1.useRef(null);
    var arrowRef = react_1.useRef(null);
    var _f = PopperContext_1.usePopperContext(), referenceElement = _f.referenceElement, popperElement = _f.popperElement, setPopperElement = _f.setPopperElement, setArrowElement = _f.setArrowElement, arrowElement = _f.arrowElement;
    react_1.useEffect(function () {
        setPopperElement(popperRef.current);
        setArrowElement(arrowRef.current);
    }, [arrowRef, popperRef, setArrowElement, setPopperElement]);
    var factor = ThemeProvider_1.useThemeContext().spacing.factor;
    var offset = offsetOption.map(function (off) { return off * factor; });
    var props = react_popper_1.usePopper(referenceElementProp || referenceElement, popperElement, __assign({ modifiers: __spread([
            { name: 'arrow', options: { element: arrowElement } },
            { name: 'eventListeners', options: { scroll: eventsEnabled, resize: eventsEnabled } },
            { name: 'offset', options: { offset: offset } }
        ], modifiers), strategy: strategy }, options));
    return __assign({ popperRef: popperRef,
        arrowRef: arrowRef }, props);
};
exports.default = usePopperPopper;
